export const SystemEndpoints = {
  version: '/system/version',
  usage: '/system/usage',
  modules: '/system/modules',
  plan: '/system/plan',
  billing: '/system/billing',
  clientApp: '/system/client-app',
};
